import { AmbientId, Mode, Settings } from '../types/pomodoro'

export const DURATION_PRESETS: Record<Mode, number[]> = {
  focus: [10, 15, 25, 30, 45, 60, 90],
  short: [3, 5, 10, 15],
  long: [15, 20, 30],
}

export const MODE_LABELS: Record<Mode, string> = {
  focus: 'Focus',
  short: 'Short break',
  long: 'Long break',
}

export const GOAL_PRESETS = [30, 60, 90, 120]

export const MIN_DURATION = 1
export const MAX_DURATION = 180

export const AMBIENT_SOUNDS: { id: AmbientId; label: string; description: string }[] = [
  { id: 'rain', label: 'Rain', description: 'Steady rainfall' },
  { id: 'forest', label: 'Forest', description: 'Leaves and distant birds' },
  { id: 'ocean', label: 'Ocean', description: 'Slow rolling waves' },
]

export const defaultSettings: Settings = {
  durations: { focus: 25, short: 5, long: 15 },
  longBreakInterval: 4,
  soundEnabled: true,
  autoStartBreaks: false,
  autoStartFocus: false,
  theme: 'system',
  notifications: false,
  dailyGoal: 60,
}
